<template>
    <div>
        <h1 class="title text-uppercase font-weight-bold">Configurações Aplicativo</h1>
        <hr class="linha-amarela" />

        <b-col
            cols="12"
            class="mb-4"
            v-for="(config, index) in configs"
            :key="index">
            <CardGpt 
                :nameConfig="config.nameConfig"
            />
        </b-col>
    </div>
</template>
<script>
import CardGpt from '@/views/administrador/CardGpt.vue'
export default {
    components: {
        CardGpt
    },

    data() {
        return {
            configs: [
                {
                    nameConfig: 'Chat GPT',
                    active: true
                }
            ]
        }
    },

    methods: {}
}
</script>